import React from 'react';
import { Collapse, Divider, Pane } from '@fullstory/components';
import { PaneProps } from '@fullstory/components/legacy/Pane';

type DetailViewElementPaneProps = PaneProps & {
  collapsable?: boolean;
  expanded?: boolean;
  header?: React.ReactNode;
};

export const DetailViewElementPane: React.FC<DetailViewElementPaneProps> = ({
  collapsable = false,
  expanded = true,
  header = null,
  children,
  ...rest
}) => {
  const content = (
    <Pane backgroundColor="default" border="standard" borderRadius={4} {...rest}>
      {header}
      {header && <Divider />}
      {children}
    </Pane>
  );
  const collapsableContent = header ? (
    <Pane backgroundColor="default" border="standard" borderRadius={4} {...rest}>
      {header}
      <Collapse expanded={expanded}>
        {header && <Divider />}
        {children}
      </Collapse>
    </Pane>
  ) : (
    <Collapse expanded={expanded}>{content}</Collapse>
  );

  return collapsable ? collapsableContent : content;
};
